import { render, staticRenderFns } from "./ChatPreviewWhatsapp.vue?vue&type=template&id=0d4085de&scoped=true&"
import script from "./ChatPreviewWhatsapp.vue?vue&type=script&lang=js&"
export * from "./ChatPreviewWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./ChatPreviewWhatsapp.vue?vue&type=style&index=0&id=0d4085de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4085de",
  null
  
)

export default component.exports